import { createSelector } from 'reselect';

import { RootState } from 'store';
import { selectIsDealDepositMadeState } from 'domains/account/actions/checkDealDeposit';
import { selectIsFreemium } from 'modules/accountStatus/store/selectors';
import { selectIsPAYGDepositMadeState } from 'domains/account/actions/checkPAYGDeposit';
import { selectIsPersonalAccount } from 'modules/account/store/selectors';

import { selectReferrer } from '../actions/fetchReferrer';

export const selectReferralProgramState = (state: RootState) =>
  state.referralProgram;

export const selectReferralCode = createSelector(
  selectReferralProgramState,
  state => state.referralCode,
);

export const selectIsAccountEligible = createSelector(
  selectIsFreemium,
  selectIsPersonalAccount,
  (isFreemium, isPersonalAccount) => isPersonalAccount && isFreemium,
);

export const selectHasReferralBonus = createSelector(
  selectReferrer,
  selectIsPersonalAccount,
  selectIsPAYGDepositMadeState,
  selectIsDealDepositMadeState,
  (
    referrer,
    isPersonalAccount,
    {
      data: isPAYGDepositMade,
      isLoading: isPAYGDepositMadeLoading,
      isUninitialized: isPAYGDepositMadeUninitialized,
    },
    {
      data: isDealDepositMade,
      isLoading: isDealDepositMadeLoading,
      isUninitialized: isDealDepositMadeUninitialized,
    },
    // eslint-disable-next-line max-params
  ) =>
    {
      const hasReferrer = Boolean(referrer);

      if (!hasReferrer || !isPersonalAccount) {
        return false;
      }

      const isUninitialized =
        isPAYGDepositMadeUninitialized || isDealDepositMadeUninitialized;
      const isLoading = isPAYGDepositMadeLoading || isDealDepositMadeLoading;
      const hasData =
        typeof isPAYGDepositMade !== 'undefined' &&
        typeof isDealDepositMade !== 'undefined';

      const isLoadingInitially = !hasData && isLoading;

      if (isUninitialized || isLoadingInitially) {
        return false;
      }

      const isDepositMade = isPAYGDepositMade || isDealDepositMade;

      return hasReferrer && !isDepositMade;
    },
);
